<script setup lang="ts">
import { RouterView } from 'vue-router'
import HeaderComponent from './components/layout/Header.vue'
import FooterComponent from './components/layout/Footer.vue'
import EyLoading from './components/EyLoading.vue'
import { globalStore } from './stores/global'

const global = globalStore()
</script>

<template>
  <HeaderComponent />
  <div class="main-component">
    <RouterView />
  </div>
  <FooterComponent />

  <EyLoading :isShow="global.isLoadingShow"/>
</template>

<style scoped lang="less">
.main-component{
  height: calc(100vh - 145px);
  overflow: auto;
  background-color: #fafafa;
}

@media (max-width: 768px) {
  .main-component{
    height: auto;
    min-height: calc(100vh - 168px);
  }
}
</style>
